import "core-js/modules/es.array.map.js";
// NOTE: the countries from '~/ab-common/src/util/filterOptions' can't be used because the data science API only accepts a subset of the countries.
// Since this is a visa probability calculator for getting a Canadian Visa, Canada won't be one of the options.
export var COUNTRIES_OF_CITIZENSHIP = [{
  value: 'AF',
  label: 'Afghanistan'
}, {
  value: 'AL',
  label: 'Albania'
}, {
  value: 'DZ',
  label: 'Algeria'
}, {
  value: 'AD',
  label: 'Andorra'
}, {
  value: 'AO',
  label: 'Angola'
}, {
  value: 'AG',
  label: 'Antigua and Barbuda'
}, {
  value: 'AR',
  label: 'Argentina'
}, {
  value: 'AM',
  label: 'Armenia'
}, {
  value: 'AU',
  label: 'Australia'
}, {
  value: 'AT',
  label: 'Austria'
}, {
  value: 'AZ',
  label: 'Azerbaijan'
}, {
  value: 'BS',
  label: 'Bahamas'
}, {
  value: 'BH',
  label: 'Bahrain'
}, {
  value: 'BD',
  label: 'Bangladesh'
}, {
  value: 'BB',
  label: 'Barbados'
}, {
  value: 'BY',
  label: 'Belarus'
}, {
  value: 'BE',
  label: 'Belgium'
}, {
  value: 'BZ',
  label: 'Belize'
}, {
  value: 'BT',
  label: 'Bhutan'
}, {
  value: 'BO',
  label: 'Bolivia'
}, {
  value: 'BA',
  label: 'Bosnia Herzegovina'
}, {
  value: 'BW',
  label: 'Botswana'
}, {
  value: 'BR',
  label: 'Brazil'
}, {
  value: 'BN',
  label: 'Brunei'
}, {
  value: 'BG',
  label: 'Bulgaria'
}, {
  value: 'BF',
  label: 'Burkina Faso'
}, {
  value: 'BI',
  label: 'Burundi'
}, {
  value: 'KH',
  label: 'Cambodia'
}, {
  value: 'CV',
  label: 'Cape Verde'
}, {
  value: 'CF',
  label: 'Central African Republic'
}, {
  value: 'TD',
  label: 'Chad'
}, {
  value: 'CL',
  label: 'Chile'
}, {
  value: 'CO',
  label: 'Colombia'
}, {
  value: 'KM',
  label: 'Comoros'
}, {
  value: 'CD',
  label: 'Congo (Democratic Republic of the)'
}, {
  value: 'CG',
  label: 'Congo'
}, {
  value: 'CR',
  label: 'Costa Rica'
}, {
  value: 'HR',
  label: 'Croatia'
}, {
  value: 'CU',
  label: 'Cuba'
}, {
  value: 'CY',
  label: 'Cyprus'
}, {
  value: 'CZ',
  label: 'Czech Republic'
}, {
  value: 'SD',
  label: 'Sudan'
}, {
  value: 'DK',
  label: 'Denmark'
}, {
  value: 'DM',
  label: 'Dominica'
}, {
  value: 'DO',
  label: 'Dominican Republic'
}, {
  value: 'EC',
  label: 'Ecuador'
}, {
  value: 'EG',
  label: 'Egypt'
}, {
  value: 'SV',
  label: 'El Salvador'
}, {
  value: 'GQ',
  label: 'Equatorial Guinea'
}, {
  value: 'ER',
  label: 'Eritrea'
}, {
  value: 'EE',
  label: 'Estonia'
}, {
  value: 'ET',
  label: 'Ethiopia'
}, {
  value: 'CM',
  label: 'Cameroon'
}, {
  value: 'DE',
  label: 'Germany'
}, {
  value: 'FJ',
  label: 'Fiji'
}, {
  value: 'FI',
  label: 'Finland'
}, {
  value: 'GA',
  label: 'Gabon'
}, {
  value: 'GM',
  label: 'Gambia'
}, {
  value: 'GE',
  label: 'Georgia'
}, {
  value: 'GH',
  label: 'Ghana'
}, {
  value: 'GR',
  label: 'Greece'
}, {
  value: 'GD',
  label: 'Grenada'
}, {
  value: 'GT',
  label: 'Guatemala'
}, {
  value: 'GW',
  label: 'Guinea-Bissau'
}, {
  value: 'GN',
  label: 'Guinea'
}, {
  value: 'GY',
  label: 'Guyana'
}, {
  value: 'HT',
  label: 'Haiti'
}, {
  value: 'HN',
  label: 'Honduras'
}, {
  value: 'HK',
  label: 'Hong Kong - SAR China'
}, {
  value: 'HU',
  label: 'Hungary'
}, {
  value: 'IS',
  label: 'Iceland'
}, {
  value: 'IN',
  label: 'India'
}, {
  value: 'IR',
  label: 'Iran'
}, {
  value: 'IQ',
  label: 'Iraq'
}, {
  value: 'IL',
  label: 'Israel'
}, {
  value: 'IT',
  label: 'Italy'
}, {
  value: 'JM',
  label: 'Jamaica'
}, {
  value: 'JP',
  label: 'Japan'
}, {
  value: 'JO',
  label: 'Jordan'
}, {
  value: 'KZ',
  label: 'Kazakhstan'
}, {
  value: 'KE',
  label: 'Kenya'
}, {
  value: 'KP',
  label: 'Korea North'
}, {
  value: 'KR',
  label: 'Korea South'
}, {
  value: 'XK',
  label: 'Kosovo'
}, {
  value: 'KW',
  label: 'Kuwait'
}, {
  value: 'KG',
  label: 'Kyrgyzstan'
}, {
  value: 'LA',
  label: 'Laos'
}, {
  value: 'LV',
  label: 'Latvia'
}, {
  value: 'LB',
  label: 'Lebanon'
}, {
  value: 'LS',
  label: 'Lesotho'
}, {
  value: 'LR',
  label: 'Liberia'
}, {
  value: 'LY',
  label: 'Libya'
}, {
  value: 'LI',
  label: 'Liechtenstein'
}, {
  value: 'LT',
  label: 'Lithuania'
}, {
  value: 'LU',
  label: 'Luxembourg'
}, {
  value: 'CN',
  label: 'China'
}, {
  value: 'MK',
  label: 'Macedonia'
}, {
  value: 'MG',
  label: 'Madagascar'
}, {
  value: 'MW',
  label: 'Malawi'
}, {
  value: 'MY',
  label: 'Malaysia'
}, {
  value: 'MV',
  label: 'Maldives'
}, {
  value: 'ML',
  label: 'Mali'
}, {
  value: 'MT',
  label: 'Malta'
}, {
  value: 'MR',
  label: 'Mauritania'
}, {
  value: 'MU',
  label: 'Mauritius'
}, {
  value: 'MX',
  label: 'Mexico'
}, {
  value: 'MD',
  label: 'Moldova'
}, {
  value: 'MC',
  label: 'Monaco'
}, {
  value: 'MN',
  label: 'Mongolia'
}, {
  value: 'ME',
  label: 'Montenegro'
}, {
  value: 'MA',
  label: 'Morocco'
}, {
  value: 'MZ',
  label: 'Mozambique'
}, {
  value: 'MM',
  label: 'Burma (Myanmar)'
}, {
  value: 'NA',
  label: 'Namibia'
}, {
  value: 'NP',
  label: 'Nepal'
}, {
  value: 'NC',
  label: 'New Caledonia'
}, {
  value: 'NZ',
  label: 'New Zealand'
}, {
  value: 'NI',
  label: 'Nicaragua'
}, {
  value: 'NG',
  label: 'Nigeria'
}, {
  value: 'NO',
  label: 'Norway'
}, {
  value: 'OM',
  label: 'Oman'
}, {
  value: 'PK',
  label: 'Pakistan'
}, {
  value: 'PS',
  label: 'Palestinian Authority'
}, {
  value: 'PA',
  label: 'Panama'
}, {
  value: 'PG',
  label: 'Papua New Guinea'
}, {
  value: 'PY',
  label: 'Paraguay'
}, {
  value: 'BJ',
  label: 'Benin'
}, {
  value: 'PE',
  label: 'Peru'
}, {
  value: 'PH',
  label: 'Philippines'
}, {
  value: 'PL',
  label: 'Poland'
}, {
  value: 'PT',
  label: 'Portugal'
}, {
  value: 'QA',
  label: 'Qatar'
}, {
  value: 'DJ',
  label: 'Djibouti'
}, {
  value: 'ID',
  label: 'Indonesia'
}, {
  value: 'IE',
  label: 'Ireland'
}, {
  value: 'CI',
  label: 'Ivory Coast'
}, {
  value: 'ZA',
  label: 'South Africa'
}, {
  value: 'NE',
  label: 'Niger'
}, {
  value: 'RO',
  label: 'Romania'
}, {
  value: 'RU',
  label: 'Russia'
}, {
  value: 'RW',
  label: 'Rwanda'
}, {
  value: 'SA',
  label: 'Saudi Arabia, Kingdom of'
}, {
  value: 'SN',
  label: 'Senegal'
}, {
  value: 'RS',
  label: 'Serbia'
}, {
  value: 'SC',
  label: 'Seychelles'
}, {
  value: 'SL',
  label: 'Sierra Leone'
}, {
  value: 'SG',
  label: 'Singapore'
}, {
  value: 'SK',
  label: 'Slovakia'
}, {
  value: 'SI',
  label: 'Slovenia'
}, {
  value: 'VN',
  label: 'Vietnam'
}, {
  value: 'SB',
  label: 'Solomon Islands'
}, {
  value: 'SO',
  label: 'Somalia'
}, {
  value: 'SS',
  label: 'South Sudan'
}, {
  value: 'ES',
  label: 'Spain'
}, {
  value: 'LK',
  label: 'Sri Lanka'
}, {
  value: 'KN',
  label: 'St Kitts and Nevis'
}, {
  value: 'LC',
  label: 'St Lucia'
}, {
  value: 'VC',
  label: 'St Vincent'
}, {
  value: 'SR',
  label: 'Suriname'
}, {
  value: 'SZ',
  label: 'Swaziland'
}, {
  value: 'SE',
  label: 'Sweden'
}, {
  value: 'CH',
  label: 'Switzerland'
}, {
  value: 'SY',
  label: 'Syria'
}, {
  value: 'TJ',
  label: 'Tajikistan'
}, {
  value: 'TW',
  label: 'Taiwan'
}, {
  value: 'TH',
  label: 'Thailand'
}, {
  value: 'NL',
  label: 'Netherlands'
}, {
  value: 'TG',
  label: 'Togo'
}, {
  value: 'TT',
  label: 'Trinidad and Tobago'
}, {
  value: 'TN',
  label: 'Tunisia'
}, {
  value: 'TR',
  label: 'Turkey'
}, {
  value: 'TM',
  label: 'Turkmenistan'
}, {
  value: 'UG',
  label: 'Uganda'
}, {
  value: 'UA',
  label: 'Ukraine'
}, {
  value: 'AE',
  label: 'United Arab Emirates'
}, {
  value: 'GB',
  label: 'United Kingdom'
}, {
  value: 'TZ',
  label: 'Tanzania'
}, {
  value: 'US',
  label: 'United States'
}, {
  value: 'UY',
  label: 'Uruguay'
}, {
  value: 'UZ',
  label: 'Uzbekistan'
}, {
  value: 'VE',
  label: 'Venezuela'
}, {
  value: 'YE',
  label: 'Yemen'
}, {
  value: 'ZM',
  label: 'Zambia'
}, {
  value: 'ZW',
  label: 'Zimbabwe'
}, {
  value: 'MP',
  label: 'Northern Mariana Islands'
}, {
  value: 'FM',
  label: 'Micronesia'
}, {
  value: 'PW',
  label: 'Palau'
}, {
  value: 'WS',
  label: 'Samoa'
}, {
  value: 'ST',
  label: 'Sao Tomé e Principe'
}, {
  value: 'AW',
  label: 'Aruba'
}, {
  value: 'BM',
  label: 'Bermuda'
}, {
  value: 'BQ',
  label: 'Bonaire, Sint Eustatius and Saba'
}, {
  value: 'PF',
  label: 'French Polynesia'
}, {
  value: 'NR',
  label: 'Nauru'
}, {
  value: 'FR',
  label: 'France'
}, {
  value: 'SX',
  label: 'Sint Maarten (Dutch part)'
}, {
  value: 'AN',
  label: 'The Netherlands Antilles'
}, {
  value: 'VU',
  label: 'Vanuatu'
}, {
  value: 'AI',
  label: 'Anguilla'
}, {
  value: 'KY',
  label: 'Cayman Islands'
}, {
  value: 'GF',
  label: 'French Guiana'
}, {
  value: 'MQ',
  label: 'Martinique'
}, {
  value: 'RE',
  label: 'Réunion'
}, {
  value: 'SM',
  label: 'San Marino'
}, {
  value: 'TO',
  label: 'Tonga'
}, {
  value: 'UM',
  label: 'United States Minor Outlying Islands'
}, {
  value: 'VA',
  label: 'Vatican City'
}, {
  value: 'EH',
  label: 'Western Sahara'
}, {
  value: 'TL',
  label: 'East Timor'
}, {
  value: 'MH',
  label: 'Marshall Islands'
}, {
  value: 'TV',
  label: 'Tuvalu'
}, {
  value: 'GL',
  label: 'Greenland'
}];
export var SUGGEST_PAGE_SIZE = 3;
export var VISA_VS_STUDY_PERMIT_LINK = 'https://www.applyboard.com/blog/whats-the-difference-between-a-student-visa-and-study-permit';
export var IRCC_LINK = 'https://www.canada.ca/en/immigration-refugees-citizenship.html';
export var FEEDBACK_GOOGLE_FORM_LINK = 'https://forms.gle/hvkTzsG6khqrL9fVA';

// For the OPTION constants, the value is the value that gets provided to the API for that selection
// The label is what's shown to the user.
// Sometimes, the label and value are the same.

export var AGE_OPTIONS = [{
  value: '20 years old and under',
  label: '20 years old and under'
}, {
  value: '21 - 25 years old',
  label: '21 - 25 years old'
}, {
  value: '26 - 30 years old',
  label: '26 - 30 years old'
}, {
  value: '31 years old and over',
  label: '31 years old and over'
}];
export var GENDER_OPTIONS = [{
  value: 'Male',
  label: 'Male'
}, {
  value: 'Female',
  label: 'Female'
}, {
  value: 'Other_gender',
  label: 'Other'
}];
export var PROVINCE_OPTIONS = [{
  value: 'Alberta',
  label: 'Alberta'
}, {
  value: 'British Columbia',
  label: 'British Columbia'
}, {
  value: 'Manitoba',
  label: 'Manitoba'
}, {
  value: 'New Brunswick',
  label: 'New Brunswick'
}, {
  value: 'Newfoundland and Labrador',
  label: 'Newfoundland and Labrador'
}, {
  value: 'Nova Scotia',
  label: 'Nova Scotia'
}, {
  value: 'Ontario',
  label: 'Ontario'
}, {
  value: 'Prince Edward Island',
  label: 'Prince Edward Island'
}, {
  value: 'Quebec',
  label: 'Quebec'
}, {
  value: 'Saskatchewan',
  label: 'Saskatchewan'
}, {
  value: 'Yukon',
  label: 'Yukon'
}];
export var COUNTRY_OF_CITIZENSHIP_OPTIONS = COUNTRIES_OF_CITIZENSHIP.map(function (_ref) {
  var label = _ref.label,
    code = _ref.value;
  return {
    label: label,
    value: label,
    code: code
  };
});
export var PROGRAM_LEVEL_OPTIONS = [{
  value: 'ESL/FSL',
  label: 'ESL/FSL',
  quickSearchProgramLevelMapping: ['english']
}, {
  value: 'Applied degree',
  label: 'Applied degree',
  quickSearchProgramLevelMapping: ['diploma']
}, {
  value: 'CEGEP - Pre-university',
  label: 'CEGEP - Pre-university',
  quickSearchProgramLevelMapping: []
}, {
  value: 'CEGEP - Technical',
  label: 'CEGEP - Technical',
  quickSearchProgramLevelMapping: []
}, {
  value: 'Certificate',
  label: 'Certificate',
  quickSearchProgramLevelMapping: ['certificate']
}, {
  value: 'College - ESL/FSL',
  label: 'College - ESL/FSL',
  quickSearchProgramLevelMapping: []
}, {
  value: 'Diploma',
  label: 'Diploma',
  quickSearchProgramLevelMapping: ['diploma', 'advanced_diploma']
}, {
  value: 'Quebec Programs - PTC/TCST/DVS/AVS',
  label: 'Quebec Programs - PTC/TCST/DVS/AVS',
  quickSearchProgramLevelMapping: []
}, {
  value: "Bachelor's",
  label: "Bachelor's",
  quickSearchProgramLevelMapping: ['3_year_bachelors', 'bachelors']
}, {
  value: "Master's",
  label: "Master's",
  quickSearchProgramLevelMapping: ['masters_degree']
}, {
  value: 'University - ESL/FSL',
  label: 'University - ESL/FSL',
  quickSearchProgramLevelMapping: []
}, {
  value: 'University - Other Studies',
  label: 'University - Other Studies',
  quickSearchProgramLevelMapping: []
}, {
  value: 'Doctorate',
  label: 'Doctorate',
  quickSearchProgramLevelMapping: ['doctoral_phd']
}];